import { IGetCheckoutPaymentMethodId } from '../types';

import { getValidPaymentMethodId } from './getValidPaymentMethodId';

/**
 * Checkout payment method can be a CC, prepaid card, Apple or Google Pay
 */
export const getCheckoutPaymentMethodId = ({
  accounts,
  usersPaymentMethodId,
  canUseApplePay,
  canUseGooglePay,
  applePayCardDetails,
  enableThDirectPayApplePay,
  googlePayCardDetails,
  enableThDirectPayGooglePay
}: IGetCheckoutPaymentMethodId) => {
  // TH want to auto select apple pay only if the user has no other payment methods
  const checkoutAccounts = accounts;
  let userCheckoutPaymentMethodId = usersPaymentMethodId;

  // Add Apple/Google Pay if it's available on the device & flag is on for TH direct pay
  // Check if the user can use apple pay at checkout
  const canUseApplePayAtCheckout = enableThDirectPayApplePay && canUseApplePay;
  if (canUseApplePayAtCheckout) {
    checkoutAccounts.unshift(applePayCardDetails);
  }
  // Check if the user can use google pay at checkout
  const canUseGooglePayAtCheckout = enableThDirectPayGooglePay && canUseGooglePay;
  if (canUseGooglePayAtCheckout) {
    checkoutAccounts.unshift(googlePayCardDetails);
  }

  // If the user has no selected payment method, we'll select the first item in the checkoutAccounts
  // Return a valid checkout payment method
  return getValidPaymentMethodId({
    paymentMethodId: userCheckoutPaymentMethodId,
    paymentMethods: checkoutAccounts
  });
};
